import script from "./ReservedBooks.vue?vue&type=script&setup=true&lang=js"
export * from "./ReservedBooks.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__